import React, { FC, useMemo, useState } from 'react';
import { object, string } from 'yup';
import { CustomObjectDefinitionCreationModelInput } from '@utmost.co/enterprise-models';
import { Dialog, AppForm, Button } from '@beeline.com/bp-design-system';
import { useTypedMutation } from 'src/utils/hooks/useTypedMutation';
import { useCustomFieldsAndObjectsIntl } from '../translations/useCustomFieldsAndObjectsIntl';
import { CreateNewObjectDocument } from './utils/__generated__/CreateNewObject.graphql';
interface Props {
  onCloseModal: () => void;
  onCreate: () => void;
  open: boolean;
}
export const CreateCustomObjectDialog: FC<React.PropsWithChildren<Props>> = ({ onCloseModal, open, onCreate }) => {
  const intl = useCustomFieldsAndObjectsIntl();
  const [model, setModel] = useState<Partial<CustomObjectDefinitionCreationModelInput>>({
    name: '',
    description: ''
  });
  const { set: createNewObject } = useTypedMutation(CreateNewObjectDocument, {
    variables: {
      customObjectDefinition: {
        name: model.name,
        description: model.description,
        fields: []
      }
    }
  });
  const handleClose = () => {
    onCloseModal();
  };
  const handleSubmit = async () => {
    const response = await createNewObject();
    if (!response.errors) {
      onCreate();
      onCloseModal();
    }
  };
  const validationSchema = useMemo(
    () =>
      object<Partial<CustomObjectDefinitionCreationModelInput>>({
        name: string().required()
      }),
    []
  );
  return (
    <Dialog
      title={intl.createCustomObject}
      onClose={handleClose}
      open={open}
      show={{ cancelButton: true }}
      disableBackdropClick
      actions={[
        <Button
          variant="contained"
          color="primary"
          key="confirm_button"
          onClick={handleSubmit}
          dataTest="confirm_button"
        >
          {intl.createCustomObject}
        </Button>
      ]}
    >
      <AppForm onChange={setModel} initialValues={model} validationSchema={validationSchema}>
        <AppForm.Control name="name">
          <AppForm.Label required>{intl.name}</AppForm.Label>
          <AppForm.Input dataTest="object-name" placeholder={intl.name} autoFocus />
          <AppForm.HelperText />
        </AppForm.Control>
        <AppForm.Control name="description" marginBottom={0}>
          <AppForm.Label>{intl.description}</AppForm.Label>
          <AppForm.Input dataTest="object-desc" placeholder={intl.description} />
          <AppForm.HelperText />
        </AppForm.Control>
      </AppForm>
    </Dialog>
  );
};
